<template>
    <div class="pb-10 ">
        <!-- Slider -->
        <div class="grid grid-cols-1">
            <Slider />
        </div>


        <!-- Kata Mereka - Testimoni -->
        <section class="px-10 2xl:px-96 bg-hijau">
            <h2 class="py-10 text-2xl uppercase text-center font-bold text-white">Kata Mereka</h2>
            <!-- Main Grid -->
            <div class="grid grid-cols-1 md:grid-cols-3 gap-4 pb-16">
                <!-- Card  -->
                <div v-for='(review, i) in reviews' :key="i" class="card bg-white rounded-lg text-center text-green-600 py-5 px-3 shadow-lg">
                    <div class="w-full">
                        <img :src="review.image" class="mx-auto object-cover rounded-full w-52 h-52">
                    </div>
                    <h3 class="text-lg font-bold py-3">{{review.nama}}</h3>
                    <p class="text-center" v-html="review.pendapat"></p>
                </div>
            </div>
        </section>
        
        <!-- Tentang Kami -->
        <section class="px-10 2xl:px-96 pb-16">
            <h2 class="py-10 text-2xl uppercase text-center font-bold text-green-600">Tentang Kami</h2>
            <iframe src="https://www.youtube.com/embed/1aEGeuqq7Lw" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen class="w-full h-96 sm:h-screen"></iframe>
        </section>

        <!-- Kabar Kita -->
        <section class="px-10 2xl:px-96 bg-hijau">
            <h2 class="py-10 text-2xl uppercase text-center font-bold text-white">Kabar Kita</h2>
            <!-- Main Grid -->
            <div class="grid grid-cols-1 md:grid-cols-3 gap-4 pb-16">
                <!-- Card 1 -->
                <div v-for="berita in beritas.slice(0,3)" :key="berita.id" class="card bg-white rounded-lg text-left pb-5 text-green-600 shadow-lg">
                    <router-link :to="{name: 'berita.show', params: {slug: berita.slug}}">
                        <div class="w-full">
                            <img :src="berita.image" alt="" class="object-cover object-center h-52 w-full rounded-t-lg">
                        </div>
                        <h3 class="text-lg font-bold pt-1 px-5">{{berita.judul}}</h3>
                        <p class="pb-2 px-5 text-sm text-gray-500">{{berita.penulis}}</p>
                        <p class="text-left px-5" v-html="berita.isi.length > 25 ? berita.isi.slice(0, 25) + '...' : berita.isi"></p>
                    </router-link>
                </div>
            </div>
        </section>

        <!-- Donasi -->
        <section class="px-10 2xl:px-96">
            <h2 class="py-10 text-2xl uppercase text-center font-bold text-green-600">Donasi</h2>
            <!-- Main Grid -->
            <div v-if="campaigns.length > 0" class="grid grid-cols-1 md:grid-cols-3 gap-4 pb-16">
                <!-- Card -->
                <div  v-for="campaign in campaigns.slice(0,3)" :key="campaign.id">
                    <div class="card bg-white rounded-lg text-left pb-5 text-green-600 shadow-lg">
                        <div class="w-full">
                            <img :src="campaign.image" alt="" class="object-cover object-center h-52 w-full rounded-t-lg">
                        </div>
                        <router-link :to="{name: 'campaign.show', params: {slug: campaign.slug}}">
                            <h3 class="text-lg font-bold py-3 px-5">{{campaign.title}}</h3>
                        </router-link>
                        <p class="text-left px-5" v-html="campaign.description.length > 100 ? campaign.description.slice(0, 100) + '...' : campaign.description"></p>
                        <div v-if="campaign.sum_donation.length > 0" class="relative my-3 px-5">
                            <div v-for="donation in campaign.sum_donation" :key="donation">
                                <div class="overflow-hidden h-2 text-xs flex rounded bg-gray-200">
                                    <div :style="{width: percentage(donation.total, campaign.target_donation) + '%'}" class="shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center bg-hijau"></div>
                                </div>
                            </div>
                        </div>
                        <div v-else class="relative my-3 px-5">
                            <div class="overflow-hidden h-2 text-xs flex rounded bg-gray-200">
                                <div :style="{width: percentage(0, campaign.target_donation) + '%'}" class="shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center bg-hijau"></div>
                            </div>
                        </div>
                        <div v-if="campaign.sum_donation.length > 0" class="flex justify-between px-5 pb-5">
                            <div class="text-left">
                                <span class="font-bold block">Terkumpul</span>
                                <div v-for="donation in campaign.sum_donation" :key="donation">
                                    <p>Rp. {{formatPrice(donation.total)}}</p>
                                </div>
                            </div>
                            <div class="text-right">
                                <span class="font-bold block">Tenggat</span>
                                <p>{{countDay(campaign.max_date)}} hari lagi</p>
                            </div>
                        </div>
                        <div v-else class="flex justify-between px-5 pb-5">
                            <div class="text-left">
                                <span class="font-bold block">Terkumpul</span>
                                <p>Rp. 0</p>
                            </div>
                            <div class="text-right">
                                <span class="font-bold block">Tenggat</span>
                                <p>{{countDay(campaign.max_date)}} hari lagi</p>
                            </div>
                        </div>
                        <div class="px-5">
                            <router-link :to="{name: 'campaign.show', params: {slug: campaign.slug}}">
                                <button class=" bg-hijau p-3 text-white w-full rounded-md font-bold text-lg uppercase">Donasi</button>
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="campaigns.length == 0" class="grid grid-cols-1 md:grid-cols-3 gap-4 pb-16">
                <h1 class="font-bold text-3xl text-center">Data Donasi belum ada</h1>
            </div>
        </section>
        
        <!-- Statistik -->
        <section class="px-10 2xl:px-96 bg-hijau">
            <h2 class="py-10 text-2xl uppercase text-center font-bold text-white">Statistik</h2>
            <!-- Main Grid -->
            <div class="grid grid-cols-2 md:grid-cols-4 gap-4 pb-16 text-white">
                <div v-for="statistik in statistiks.slice(0,4)" :key="statistik.id" class="text-center">
                    <h3 class="font-bold text-3xl">
                        <number
                            ref="number1"
                            :from="100"
                            :to="statistik.angka"
                            :format="theFormat"
                            :duration="5"
                            :delay="2"
                            easing="Power1.easeOut"/>
                    </h3>
                    <p>{{statistik.status}}</p>
                </div>
            </div>
        </section>
        
        <!-- Sponsor -->
        <section class="px-10 2xl:px-96 mb-8">
            <h2 class="py-10 text-2xl uppercase text-center font-bold text-green-600">Sponsor Kami</h2>
            <Sponsor/>
        </section>

        <!-- Whatsapp -->
        <WhatsappButton />

    </div>
</template>

<script>

    //hook vue
    import { computed, onMounted } from 'vue'

    //vuex
    import { useStore } from 'vuex'

    //component slider
    import Slider from '@/components/Slider.vue'

    // component Sponsor
    import Sponsor from '@/components/Sponsor.vue'

    // component WhatsappButton
    import WhatsappButton from '@/components/WhatsappButton.vue'

    export default {

        components: {
            Slider,         // <-- register component slider
            WhatsappButton,
            Sponsor
        },

        setup() {

            //store vuex
            const store = useStore()

            //onMounted akan menjalankan action "getCampaign" di module "campaign"
            onMounted(() => {
                store.dispatch('campaign/getCampaign')
                store.dispatch('review/getReview')
                store.dispatch('berita/getBerita')
                store.dispatch('statistik/getStatistik')
            })

            //digunakan untuk get data  state "campaigns" di module "campaign" 
            const campaigns = computed(() => {
                return store.state.campaign.campaigns
            })

            // Storing Data
            const reviews = computed(() => {
                return store.state.review.reviews
            })

            // Storing Berita
            const beritas = computed(() => {
                return store.state.berita.beritas
            })

            // Storing Statistik
            const statistiks = computed(() => {
                return store.state.statistik.statistiks
            })

            /**
             * LOADMORE
             */

            //get status NextExists
            const nextExists = computed(() => {
                return store.state.campaign.nextExists
            })

            //get nextPage
            const nextPage = computed(() => {
                return store.state.campaign.nextPage
            })

            //loadMore function
            function loadMore() {
                store.dispatch('campaign/getLoadMore', nextPage.value)
            }   

            return {
                campaigns,      // <-- return campaigns
                reviews,        // <-- return reviews
                beritas,        // <-- return beritas
                statistiks,     // <-- return statistiks
                nextExists,     // <-- return nextExists,
                nextPage,       // <-- return nextPage
                loadMore,        // <-- return loadMore
            }
        }
    }
</script>